var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAgentDraftingAssistant = function SvgAgentDraftingAssistant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 22C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10-4.48 10-10 10m-.637-14.451a.67.67 0 0 1 1.284 0l1.637 4.892h.01c.47 0 .863.353.96.843l1.226 5.745A8.33 8.33 0 0 0 20.333 12 8.326 8.326 0 0 0 12 3.667 8.326 8.326 0 0 0 3.667 12a8.33 8.33 0 0 0 3.862 7.04l1.226-5.765c.098-.48.5-.834.96-.834h.01zM12 20.333a8.3 8.3 0 0 0 3.314-.686l-1.265-5.941H9.961l-1.265 5.95a8.4 8.4 0 0 0 3.304.677"
  })));
};
export default SvgAgentDraftingAssistant;